import React from "react";

import { useState } from "react";
import { loginUser } from "../api";
import { Button, TextField, Typography, Box } from "@mui/material";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleAdminLogin = async () => {
        const response = await loginUser(email, password);
        if (response.token) {
            // Check if user has admin role from backend response
            if (response.user && response.user.role === "admin") {
                localStorage.setItem("adminToken", response.token);
                localStorage.setItem("user", JSON.stringify(response.user));
                setMessage("Admin Login successful!");
                // Redirect to admin dashboard after successful login
                setTimeout(() => {
                    window.location.href = '/admin-dashboard';
                }, 1000);
            } else {
                setMessage("You are not authorized as Admin.");
            }
        } else {
            setMessage(response.message);
        }
    };

    return (
        <Box sx={{ width: 300, margin: "auto", mt: 5 }}>
            <Typography variant="h5">Admin Login</Typography>
            <TextField label="Email" fullWidth margin="normal" onChange={(e) => setEmail(e.target.value)} />
            <TextField label="Password" type="password" fullWidth margin="normal" onChange={(e) => setPassword(e.target.value)} />
            <Button variant="contained" fullWidth onClick={handleAdminLogin}>Login</Button>
            <Typography>{message}</Typography>
        </Box>
    );
}
